import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';

import { log } from '../../../services/utils';

import styles from './nav-item.module.css';

const NavItem = ( {
	className,
	icon,
	inline,
	title,
	to,
	...props
} ) => {
	return (
		<>
			{ log( '- navItem' ) }
			<NavLink
				to={ to }
				activeClassName={ styles.selected }
				className={ inline ? `${ styles.inlineNavItem } ${ className }` : `${ styles.navItem } ${ className }` }
				{ ...props }
			>
				<Icon name={ icon }/>
				{ title }
			</NavLink>
		</>
	);
};

NavItem.propTypes = {
	className: PropTypes.string,
	icon: PropTypes.string.isRequired,
	inline: PropTypes.bool,
	title: PropTypes.string.isRequired,
	to: PropTypes.string
};

export default memo( NavItem );
